<template>
<section class="price-image-section _preview-section" v-if="priceImageDatas.length > 0">
    <div class="section-inner">
        <h2 class="heading-section _price-range">Price range<span>(参考上代になります)</span></h2>

        <div class="price-image-card-wrap">

            <swiper class="swiper-container"
                :navigation='{
                    "prevEl": ".swiper-btn-wrap._price-image .price-image-prev",
                    "nextEl": ".swiper-btn-wrap._price-image .price-image-next"
                } '
                :grabCursor="true"
                :slides-per-view="1.5"
                :space-between="26"
                :speed="500"
                :breakpoints="{
                    '640': {
                        slidesPerView: 5,
                        spaceBetween: 26,
                    },
                }"
            >

                <!--ControlBtn-->
                <div class="swiper-btn-wrap _price-image">
                    <button type="button" class="price-image-prev" style=" transform: scale(-1, 1);"><span></span></button>
                    <button type="button" class="price-image-next"><span></span></button>
                </div>

                <!--ITEM-->
                <swiper-slide v-for="(data, index) in priceImageDatas" v-bind:key="index">
                    <figure class="price-image-card">
                        <div class="img form_file-img md_no-image">
                            <img v-bind:src="data.image" alt="">
                        </div>
                        <div class="detail">
                            <figcaption><h3>{{ data.name }}</h3></figcaption>
                            <p><span>{{ setStringToPrice(data.price) }}</span></p>
                            <p class="comment">{{ data.description }}</p>
                        </div>
                        <p class="stock" v-if="data.stock == true"><span>in stock</span></p>
                    </figure>
                </swiper-slide>

            </swiper>

        </div><!--/.price-image-card-wrap-->

    </div><!--/.section-inner-->
</section>
</template>

<script>

    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        Pagination,
        Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        Pagination,
        Navigation
    ]);

    export default {
        components: {
            //Swiper.js
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                prices: [],
            };
        },
        props: {
            priceImages: Object,
        },
        methods: {
            setStringToPrice(num) {
                var price = '￥' + Number(num).toLocaleString();
                return price;
            }
        },
        computed: {
            priceImageDatas() {
                if (this.priceImages) {
                    var datalists = [];
                    for (let i = 0; i < Object.keys(this.priceImages).length; i++) {
                        if (this.priceImages[i+1].image != "/img/no-image.svg" || this.priceImages[i+1].name || this.priceImages[i+1].price || this.priceImages[i+1].description) {
                            datalists.push(this.priceImages[i+1]);
                        }
                    }
                    return datalists;
                }
            }
        }
    }
</script>